import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { personById } from "../../store/person/actions";
export var GetPersonById = function (trigger, personId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responsePersonById: state.Person.responsePersonById,
        errorPersonById: state.Person.errorPersonById,
        loadingPersonById: state.Person.loadingPersonById,
    }); }), responsePersonById = _a.responsePersonById, errorPersonById = _a.errorPersonById, loadingPersonById = _a.loadingPersonById;
    useEffect(function () {
        if (trigger) {
            dispatch(personById(personId));
        }
    }, [trigger, personId]);
    return {
        responsePersonById: responsePersonById,
        errorPersonById: errorPersonById,
        loadingPersonById: loadingPersonById,
    };
};
